import EditContactPhone from './editContactphone.modal.html';
import { find as _find } from 'lodash';
import { without as _without } from 'lodash';

class ContactPhonesController {
  constructor($scope, $uibModal, lookupService) {
    "ngInject";

    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.lookupService = lookupService;

    this.initializeEnumLookups();

    this.errMsg = '';
  }

  initializeEnumLookups() {
    const ctrl = this;
    ctrl.selectDefaults = {};

    const lookups = ['PhoneType'];

    this.lookupService.lookupEnums(lookups)
      .then(enumLookupCollection => {
        const pleaseSelectOption = {id: null, name: 'Please Select'};
        enumLookupCollection.phoneType.unshift(pleaseSelectOption);

        this.enumLookupCollection = enumLookupCollection;
        this.selectDefaults.phoneType = pleaseSelectOption;
      });
  }

  editContactPhone(phone) {
    this.errMsg = '';
    this.saveButtonTitle = 'Add';

    if (phone) {
      this.selectDefaults.phoneType = _find(this.enumLookupCollection.phoneType, o => o.id === phone.phoneType);
      this.tempPhoneNo = phone.phone;

      phone.editMode = true;
      this.editPhone = phone;

      this.saveButtonTitle = 'Update';
    }

    this.$uibModalInstance = this.$uibModal.open({
        template: EditContactPhone,
        scope: this.$scope
    });
  }

  closeModal() {
    this.selectDefaults.phoneType = this.enumLookupCollection.phoneType[0];
    this.tempPhoneNo = '';
    this.$uibModalInstance.close();

    if (this.editPhone) {
      this.editPhone.editMode = false;
    }
  }

  addPhone() {
    if (this.selectDefaults.phoneType.id === null) {
      this.errMsg = 'Please select a Phone Type';
      return;
    }

    if (!this.tempPhoneNo) {
      this.errMsg = 'Please enter a Phone Number';
      return;
    }

    const phone = _find(this.container.contactPhones, o => !o.editMode && o.phone === this.tempPhoneNo);
    if (phone) {
      this.errMsg = 'This Phone No is already added to the list';
      return;
    }

    if (!this.editPhone) {
      this.container.contactPhones.push({
        phoneType: this.selectDefaults.phoneType.id,
        phoneTypeName: this.selectDefaults.phoneType.name,
        phone: this.tempPhoneNo,
      });
    }
    else {
      this.editPhone.phoneType = this.selectDefaults.phoneType.id;
      this.editPhone.phoneTypeName = this.selectDefaults.phoneType.name;
      this.editPhone.phone = this.tempPhoneNo;
    }

    this.closeModal();
  }

  removePhone(phone) {
    this.container.contactPhones = _without(this.container.contactPhones, phone);
  }
}

export default ContactPhonesController;



// WEBPACK FOOTER //
// ./client/app/components/common/contactPhones/contactPhones.controller.js